import styles from './Chevron.module.scss';
import ChevronDown from '~/icons/chevron-down.svg';
import clsx from 'clsx';

interface ChevronProps {
    isOpen?: boolean;
    className?: string;
}

export const Chevron: React.FC<ChevronProps> = ({ isOpen, className }) => (
    <ChevronDown
        className={clsx(styles.chevron, className, {
            [styles.open]: isOpen,
            [styles.closed]: !isOpen,
        })}
    />
);
